const SELECTORS = {
  SEARCH_INPUT: '#NavMobileSearchInput',
  NAV_ITEM: '.nav-mobile__item',
  NAV_SUBLIST: '.nav-mobile__sublist',
  NAV_PANE: '.nav-mobile__pane',
}

const NAV_ITEM_ACTIVE_CLASS = 'nav-mobile__item--is-active'
const NAV_PANE_ACTIVE_CLASS = 'nav-mobile__pane--is-active'
const NAV_SUBLIST_ACTIVE_CLASS = 'nav-mobile__sublist--is-active'

export default () => {
  $('[data-target]').on('click.nav', (event) => {
    setActiveMenuTier(event.currentTarget.dataset.target)
  })

  $(SELECTORS.SEARCH_INPUT).on({
    focus: (event) => {
      $(event.currentTarget).closest(SELECTORS.NAV_ITEM).addClass(NAV_ITEM_ACTIVE_CLASS)
    },
    blur: (event) => {
      $(event.currentTarget).closest(SELECTORS.NAV_ITEM).removeClass(NAV_ITEM_ACTIVE_CLASS)
    },
  })
}

export function setActiveMenuTier(handle) {
  const $allSubMenus = $(`${SELECTORS.NAV_SUBLIST}[data-parent]`)
  const $subMenu = $(`${SELECTORS.NAV_SUBLIST}[data-parent="${handle}"]`)
  const $subMenuPane = $subMenu.closest(SELECTORS.NAV_PANE)

  $subMenuPane
    .addClass(NAV_PANE_ACTIVE_CLASS)
    .siblings()
    .removeClass(NAV_PANE_ACTIVE_CLASS)

  $allSubMenus.removeClass(NAV_SUBLIST_ACTIVE_CLASS)
  $subMenu.addClass(NAV_SUBLIST_ACTIVE_CLASS)
}



// WEBPACK FOOTER //
// ./nav-mobile.js